<template>
  <div class="flex flex-col justify-center h-52">
    <div class="text-center">
      <div>{{ $i18nPresenter.t('Cannot retrieve your presentation list.') }}</div>

      <div>
        <span>{{ $i18nPresenter.t('Please') }}</span>
        <a @click.stop="getAllUserPresentationsAndFolders()" class="cursor-pointer primary-color">
          {{ $i18nPresenter.t('click here') }}
        </a>
        <span>{{ $i18nPresenter.t('to try again.') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getAllUserPresentationsAndFolders() {
      this.$emit('getAllUserPresentationsAndFolders')
    },
  },
}
</script>
